import { render, staticRenderFns } from "./GoBackButton.vue?vue&type=template&id=21849d9c&scoped=true&"
import script from "./GoBackButton.vue?vue&type=script&lang=js&"
export * from "./GoBackButton.vue?vue&type=script&lang=js&"
import style0 from "./GoBackButton.vue?vue&type=style&index=0&id=21849d9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21849d9c",
  null
  
)

export default component.exports